export default import.meta.ROLLUP_FILE_URL_YNA0m1xGCKdPBZ2PZ0oDAQ